import styled from 'styled-components';
import { Col } from 'tno-core/dist/components/flex';

export const SourceMetrics = styled(Col)``;
